import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./FileIcon.styled"

export const FileIcon = (props) => {
    const {
        extension,
        variant,
    } = props

    return (
        <Styled.IconWrapper variant={variant}>
            <Styled.Icon variant={variant} />
            <Styled.Badge variant={variant}>
                <Styled.ExtensionText variant={variant}>{extension || "file"}</Styled.ExtensionText>
            </Styled.Badge>
        </Styled.IconWrapper>
    )
}

FileIcon.propTypes = {
    extension: PropTypes.string.isRequired,
}